import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export const useGetAccessToken = () => {
  const [token, setToken] = useState("");
  const { getAccessTokenSilently, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;
    getAccessTokenSilently()
      .then(setToken)
      .catch(() => setToken(""));
  }, [getAccessTokenSilently, isLoading]);

  return { token };
};
